import { InputHTMLAttributes, Ref } from 'react';
import { cn } from '@/lib/utils';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  ref?: Ref<HTMLInputElement>;
}

const Checkbox = ({ className, ref, ...props }: CheckboxProps) => (
  <input
    type="checkbox"
    className={cn(
      'h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 checked:bg-primary checked:text-primary-foreground accent-primary',
      className
    )}
    ref={ref}
    {...props}
  />
);

export { Checkbox };
